module.exports = __webpack_public_path__ + "img/icon_xr.db97f8de.png";